
import ControllerSearch from 'Controllers/ControllerSearch'

export default {
  components: {
    ControllerSearch,
  },
}
